import { Switch as SwitchPrimitive } from 'radix-ui'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

function Switch({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                'peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent',
                'transition-colors duration-(--animate-duration)',
                'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
                'outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
                'disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...props}>
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={cn(
                    // 16px thumb in an 18px track: 2px of breathing room at either end.
                    'pointer-events-none block size-4 rounded-full bg-card shadow-sm dark:bg-foreground',
                    'transition-transform duration-(--animate-duration) ease-(--ease-out-quart)',
                    'data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0.5'
                )}
            />
        </SwitchPrimitive.Root>
    )
}

export { Switch }
